import { render, staticRenderFns } from "./PasswordGuardPASS.vue?vue&type=template&id=0d8b3c6f&"
import script from "./PasswordGuardPASS.vue?vue&type=script&lang=js&"
export * from "./PasswordGuardPASS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports